import {ErrorCode} from './error-code';
import {UnprocessableEntityError} from './UnprocessableEntityError';

export class InsufficientWalletBalanceError extends UnprocessableEntityError {
    constructor(message?: string) {
        super(ErrorCode.InsufficientWalletBalance, message);
        Object.setPrototypeOf(this, InsufficientWalletBalanceError.prototype);
    }
}